var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Glyphs/Earth") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glyphs/Earth",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "earth-1",
    transform: "translate(5.000000, 5.000000)",
    stroke: "currentColor",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 8.98875,
    r: 8.625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.50475,7.48874977 L5.06775,7.48874977 C5.66459056,7.48847959 6.23708479,7.72535514 6.65925,8.14725 L7.5,8.988 C8.34268714,9.83042842 8.3824814,11.1837621 7.59075,12.07425 L6.5685,13.224 C6.20235147,13.6358222 6.00006392,14.1676944 6,14.71875 L6,17.0775",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.19575,2.98875 L10.84575,2.98875 C9.91376948,2.98875 9.15825,3.74426948 9.15825,4.67625 C9.15825,5.60823052 9.91376948,6.36375 10.84575,6.36375 L11.16975,6.36375 C11.9229393,6.36263358 12.6267303,6.73845799 13.04475,7.365 L14.70825,9.86175 C15.1260977,10.4885775 15.8299184,10.8646993 16.58325,10.8637518 L17.424,10.8637518",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.c8f2930e.svg";
export { ForwardRef as ReactComponent };